import React, { useEffect, useState } from 'react';
import './key.css';

function isDesktop() {
    // Puedes ajustar la lógica según tu app desktop
    return window.innerWidth > 1024 || navigator.userAgent.includes('Electron');
}

function Keyboard({ txt, setTxt, showVirtualKeyboard, setShowVirtualKeyboard }) {
    const [keyboardMode, setKeyboardMode] = useState('letters_upper');


    useEffect(() => {
        setTxt('');
        setKeyboardMode('letters_upper');
        if (isDesktop()) {
            setShowVirtualKeyboard(true);
        }
    }, [setTxt]);

    const appendToTxt = (value) => {
        setTxt((prev) => prev + value);
    };

    const removeLastTxtChar = () => {
        setTxt((prev) => prev.slice(0, -1));
    };

    // Teclados optimizados
    const alphaKeyboardRows = [
        ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
        ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
        ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
    ];
    const alphaLowerKeyboardRows = [
        ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
        ['z', 'x', 'c', 'v', 'b', 'n', 'm']
    ];
    const numericKeyboardRows = [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['0']
    ];
    const symbolKeyboardRows = [
        ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'],
        ['-', '_', '=', '+', '[', ']', '{', '}', ';', ':'],
        ['.', ',', '/', '?', '|', '\\', "'", '"']
    ];

    // Renderiza una fila de teclas
    const renderRow = (row, keyStyle = {}) => (
        <div className="spl-kb-row">
            {row.map((key) => (
                <button
                    key={key}
                    type="button"
                    className="spl-kbkey"
                    style={keyStyle}
                    onClick={() => appendToTxt(key)}
                >
                    {key}
                </button>
            ))}
        </div>
    );

    // Renderiza el teclado según el modo
    const renderKeyboard = () => {
        switch (keyboardMode) {
            case 'letters_upper':
                return (
                    <>
                        {alphaKeyboardRows.map((row) => renderRow(row))}
                        <div className="spl-kb-actions">
                            <button type="button" className="spl-kb-act spl-kb-del" onClick={removeLastTxtChar}>
                                ← Borrar
                            </button>
                            <button type="button" className="spl-kb-act spl-kb-shift" onClick={() => setKeyboardMode('letters_lower')}>
                                MAYÚSCULAS
                            </button>
                        </div>
                    </>
                );
            case 'letters_lower':
                return (
                    <>
                        {alphaLowerKeyboardRows.map((row) => renderRow(row))}
                        <div className="spl-kb-actions">
                            <button type="button" className="spl-kb-act spl-kb-del" onClick={removeLastTxtChar}>
                                ← Borrar
                            </button>
                            <button type="button" className="spl-kb-act spl-kb-shift" onClick={() => setKeyboardMode('letters_upper')}>
                                Minúsculas
                            </button>
                        </div>
                    </>
                );
            case 'numbers':
                return (
                    <>
                        {numericKeyboardRows.map((row) => renderRow(row))}
                        <div className="spl-kb-actions">
                            <button type="button" className="spl-kb-act spl-kb-del" onClick={removeLastTxtChar}>
                                ← Borrar
                            </button>
                        </div>
                    </>
                );
            case 'symbols':
                return (
                    <>
                        {symbolKeyboardRows.map((row) => renderRow(row))}
                        <div className="spl-kb-actions">
                            <button type="button" className="spl-kb-act spl-kb-del" onClick={removeLastTxtChar}>
                                ← Borrar
                            </button>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="spl-kb">
            {/* Switch solo visible en desktop */}
            {isDesktop() && (
                <div className="spl-kb-switch">
                    <label className="spl-switch">
                        <input
                            type="checkbox"
                            id="toggleKeyboardInput"
                            checked={!showVirtualKeyboard}
                            onChange={() => setShowVirtualKeyboard((prev) => !prev)}
                        />
                        <span className="spl-track"></span>
                        <span className="spl-knob"></span>
                    </label>
                    <label className="spl-kb-switch-lbl" htmlFor="toggleKeyboardInput">
                        Usar teclado físico
                    </label>
                </div>
            )}
            {/* Botones y teclado virtual solo si está habilitado */}
            {/*showVirtualKeyboard && (
                <>}*/}
            <div className="spl-seg">
                <button
                    type="button"
                    className={`spl-kb-mode ${keyboardMode.includes('letters') ? 'spl-active' : ''}`}
                    onClick={() => setKeyboardMode('letters_upper')}
                >
                    ABC
                </button>
                <button
                    type="button"
                    className={`spl-kb-mode ${keyboardMode === 'numbers' ? 'spl-active' : ''}`}
                    onClick={() => setKeyboardMode('numbers')}
                >
                    123
                </button>
                <button
                    type="button"
                    className={`spl-kb-mode ${keyboardMode === 'symbols' ? 'spl-active' : ''}`}
                    onClick={() => setKeyboardMode('symbols')}
                >
                    #+=
                </button>
            </div>
            {renderKeyboard()}
            {/* </>
            )}*/}
        </div>
    );
}

export default Keyboard;